"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configuration_1 = require("../configuration");
var SpecialPriceController_1 = require("./SpecialPriceController");
var DiscountController = (function () {
    function DiscountController() {
    }
    DiscountController.setEmptyAdditionalData = function (placement) {
        if (!placement.additionalData) {
            placement.additionalData = {};
            placement.additionalData.specialPriceData = {};
            DiscountController.setAdditionalData(placement);
        }
    };
    DiscountController.setAdditionalData = function (placement) {
        var theData = {};
        var theFcImpressions = _.get(placement, "frequencyCapping.impressions");
        theData.frequencyCappingFormatted = theFcImpressions !== undefined ? theFcImpressions.toString() : "";
        var fcForTotal = (_.get(placement, "frequencyCapping.forTotal"));
        if (theFcImpressions !== undefined
            && _.get(placement, "additionalData.frequencyCappingForTotal")
            && _.get(placement, "additionalData.frequencyCappingForTotal") !== configuration_1.PlanConfiguration.ERROR_STRING) {
            fcForTotal = _.get(placement, "additionalData.frequencyCappingForTotal");
        }
        theData.frequencyCappingForTotal = fcForTotal;
        theData.specialDiscount = DiscountController.getSpecialDiscount(placement.specialDiscounts);
        theData.specialPriceData = DiscountController.compileSpecialPriceData(placement);
        theData.ignoreFrequencyString = DiscountController.getIgnoreFrequencyString(placement.conditions.online);
        placement.additionalData = theData;
    };
    DiscountController.getIgnoreFrequencyString = function (online) {
        if (!_.get(online, "specialFixedPriceIgnoresFrequency")) {
            return undefined;
        }
        return online.specialFixedPriceIgnoresFrequency ? "ignoriert" : "berücksichtigt";
    };
    DiscountController.compileSpecialPriceData = function (placement) {
        var theSpecialPriceData = {};
        var online = placement.conditions.online;
        theSpecialPriceData.proprietaryName = placement.additionalData.proprietaryName;
        theSpecialPriceData.description = SpecialPriceController_1.SpecialPriceController.assignSpecialPriceName(online);
        if (online) {
            if (online.specialCpm) {
                theSpecialPriceData.specialCpmAmount = online.specialCpm;
            }
            else if (online.specialFixedPrice || placement.share === 1) {
                theSpecialPriceData.specialFixedPriceAmount = online.specialFixedPrice;
                if (online.specialFixedPriceIgnoresFrequency === false) {
                    theSpecialPriceData.specialFixedPriceAmount *= placement.frequency;
                }
                theSpecialPriceData.specialFixedPriceIgnoresFrequency = online.specialFixedPriceIgnoresFrequency;
            }
        }
        return theSpecialPriceData;
    };
    DiscountController.updateSpecialDiscounts = function (discounts, conditions) {
        if (!discounts) {
            discounts = {};
        }
        if (!conditions) {
            conditions = {};
        }
        discounts.type = discounts.type !== undefined ? discounts.type : "additive";
        discounts.amount1 = discounts.amount1 !== undefined ? discounts.amount1 : 0;
        discounts.amount2 = discounts.amount2 !== undefined ? discounts.amount2 : 0;
        discounts.amount3 = discounts.amount3 !== undefined ? discounts.amount3 : 0;
        discounts.amount4 = discounts.amount4 !== undefined ? discounts.amount4 : 0;
        discounts.amount5 = discounts.amount5 !== undefined ? discounts.amount5 : 0;
        conditions.agencyCommission = conditions.agencyCommission !== undefined ? conditions.agencyCommission : 0;
        conditions.cashDiscount = conditions.cashDiscount !== undefined ? conditions.cashDiscount : 0;
        conditions.vat = conditions.vat !== undefined ? conditions.vat : 0;
    };
    DiscountController.getSpecialDiscount = function (discounts) {
        if ((discounts) &&
            ((discounts.amount1 && discounts.amount1 !== 0) ||
                (discounts.amount2 && discounts.amount2 !== 0) ||
                (discounts.amount3 && discounts.amount3 !== 0) ||
                (discounts.amount4 && discounts.amount4 !== 0) ||
                (discounts.amount5 && discounts.amount5 !== 0))) {
            return "Individuell";
        }
        return "Keinen";
    };
    DiscountController.setDiscountsToZero = function (discounts) {
        discounts.amount1 = 0;
        discounts.amount2 = 0;
        discounts.amount3 = 0;
        discounts.amount4 = 0;
        discounts.amount5 = 0;
        discounts.type = "additive";
    };
    return DiscountController;
}());
exports.DiscountController = DiscountController;
//# sourceMappingURL=discountController.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/discountController.js
// module id = 51
// module chunks = 0